var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrizes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Prizes"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prizes",
    clipPath: "url(#clip-Prizes)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-trophy-1105599",
    transform: "translate(-136.157 -95.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M157.19,99.6H154.28V99a.832.832,0,0,0-.832-.832H143.84a.832.832,0,0,0-.832.832v.6H140.1a1.94,1.94,0,0,0-1.94,1.94v2.495a4.713,4.713,0,0,0,4.713,4.713h.956a5.638,5.638,0,0,0,3.986,2.656v1.663h-1.43a2.265,2.265,0,0,0-2.262,2.262.832.832,0,1,0,1.663,0,.6.6,0,0,1,.6-.6h4.524a.6.6,0,0,1,.6.6.832.832,0,1,0,1.663,0,2.265,2.265,0,0,0-2.262-2.262h-1.43V111.4a5.638,5.638,0,0,0,3.989-2.661h.956a4.713,4.713,0,0,0,4.713-4.713v-2.5a1.94,1.94,0,0,0-1.943-1.938Zm-14.323,7.485h0a3.049,3.049,0,0,1-3.049-3.049v-2.495a.277.277,0,0,1,.277-.277h2.911v4.577a5.609,5.609,0,0,0,.144,1.247Zm9.749-1.247h0a3.972,3.972,0,0,1-7.945,0V99.829h7.945Zm4.851-1.8h0a3.049,3.049,0,0,1-3.049,3.049h-.277a5.621,5.621,0,0,0,.144-1.248v-4.574H157.2a.277.277,0,0,1,.277.277Z",
    fill: "#505358"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrizes);
export default __webpack_public_path__ + "static/media/Prizes.a853128e1589fc93f0a6768dce0c00a3.svg";
export { ForwardRef as ReactComponent };